import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ApiserviceService } from 'src/app/core/services/apiservice.service';
import { LanguageService } from 'src/app/core/services/language.service';
import { getPermissionServerList, language, savePermissionServer, updateLanguage, updateLanguageServer, getWebAdminPermission } from 'src/app/models/apiService.model';
import { ModalService } from '../_modal/modal.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import { NotificationService } from '../../toastr-notification/toastr-notification.service';

@Component({
  selector: 'app-context-menu',
  templateUrl: './context-menu.component.html',
  styleUrls: ['./context-menu.component.scss']
})
export class ContextMenuComponent implements OnInit {

  @Input() key = ''
  @Input() Permissionkey = ''
  @Input() text = 'Edit Able'
  @Input() default = ''

  languageData = JSON.parse(localStorage.getItem('language')!) as language;
  passive: boolean = true;
  editlanguage: any;
  permissionData: any;
  apiResponse: any;
  updateLanguageServer!: updateLanguageServer;
  languageSelected!: string;
  savePermissionServer!: savePermissionServer;
  permissionArray!: savePermissionServer[];
  adminPermissions = {
    label: false,
    permission: false
  }

  constructor(private languageService: LanguageService, private modalService: ModalService,
    private apiService: ApiserviceService, private loaderService: LoaderService,
    private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.editlanguage = new updateLanguage();
    this.subscribeToLanguage();
    this.getContextMenuPermission();
  }
  subscribeToLanguage() {
    this.languageService.$language.subscribe((language: language) => {
      this.languageData = language;
      this.setLanguageText();
    });
  }
  setLanguageText() {
    if (this.languageData[this.key]) {
      this.text = this.languageData[this.key]
    }
    // else {
    //   this.text;
    // }
  }

  ngOnChanges() {
    this.setLanguageText();
  }

  openModal(id: string) {
    this.modalService.open(id);
  }
  closeModal(id: string) {
    this.modalService.close(id);
  }
  Permission(text: string) {
    // this.getWebAdminPermission(this.Permissionkey);
    this.getWebAdminPermission(this.key);
    this.openModal('permission' + this.key);
  }
  Language(key: string) {
    this.languageSelected = localStorage.getItem('activeLanguage')!;
    this.editlanguage = new updateLanguage();
    this.editlanguage.key = this.key;
    this.editlanguage.default = this.default;
    if (this.languageData[key])
      this.editlanguage.text = this.languageData[key];
    else
      this.editlanguage.text = ''
    this.openModal('language' + this.key);
  }

  savePermission() {
    this.permissionArray = [];
    for (var d of this.permissionData) {
      this.permissionArray.push({
        // object_name: this.Permissionkey,
        object_name: this.key,
        sec_id: d.sec_id.toString(),
        type: d.sec_type.toString(),
        allow_edit: d.allow_edit == true ? '1' : '0',
        allow_view: d.allow_view == true ? '1' : '0',
        staff_uid: "1c4a3b87-bb65-4e70-b08c-0fbfa06a"
      })
    }
    this.saveWebAdminPermission(this.permissionArray);
    this.closeModal('permission' + this.key);
  }
  saveLanguage() {
    let languageData = new updateLanguageServer();
    languageData.language_code = localStorage.getItem('activeLanguage')!;
    languageData.menu_code = 'EN';
    languageData.lbl_name = this.editlanguage.key;
    languageData.lbl_value = this.editlanguage.text;
    languageData.staff_uid = '31c5e3c4-c8a9-40ec-a090-029a2bd4';
    // this.apiService.updateLanguageServer(languageData).subscribe(
    //   success => {
    //     this.closeModal('language' + this.key);
    //   }
    // )
    this.loaderService.start();
    this.apiService.updateLanguageServer(languageData).subscribe(
      // success => {
      //   try {
      //     this.notificationService.success('Label updated Successfully');
      //     this.closeModal('language' + this.key);
      //   }
      //   catch {
      //     this.notificationService.error('Warning');
      //   }
      //   finally {
      //     this.notificationService.error('Warning');
      //     this.loaderService.stop();
      //   }
      // }
      (resp) => {
        this.closeModal('language' + this.key);
        this.notificationService.success('Label ' + resp);
      },
      (error) => {
        // console.log(error.error);
        this.notificationService.error(error.error);
      }
    )
    this.loaderService.stop();
  }
  getWebAdminPermission(key: string) {
    this.loaderService.start();
    this.permissionData = [];
    let data = new getWebAdminPermission;
    data.object_name = key;
    this.apiService.getWebAdminPermission(data).subscribe((response) => {
      this.apiResponse = response;
      this.permissionData = this.apiResponse as getPermissionServerList;
    });
    this.loaderService.stop();
  }
  saveWebAdminPermission(data: any) {
    this.loaderService.start();
    this.apiService.saveWebAdminPermission(data).subscribe(
      (response) => {
        this.apiResponse = response;
        this.closeModal('language' + this.key);
        this.notificationService.success('Permission Updated ' + response);
      },
      (error) => {
        // console.log(error.error);
        this.notificationService.error(error.error);
      }
    );

    this.loaderService.stop();
  }

  getContextMenuPermission() {
    const data = JSON.parse(localStorage.getItem('currentToken')!);
    if (!data) {
      return
    }
    if (data.su_admin == 1) {
      this.adminPermissions.label = true;
      this.adminPermissions.permission = true;

    }

    if (data.label_admin == 1) {
      this.adminPermissions.label = true;
    }

    if (data.permission_admin == 1) {
      this.adminPermissions.permission = true;
    }
  }

}